export default __webpack_public_path__ + "static/media/emr.5cc6b828.svg";